import { isSodimacStandalone, isTottusStandalone, updateCartQtyLimits } from '@digital-retail/store-manager';
import apiConfig from '../../config/api/apiConfig';
import { CookieStorage } from '../CookieStorage';
import { httpService } from '../httpService';
import _ from '../LodashImports';
import Logger from '../Logger';
import { getCommerceHeaders } from '../tenantHelper';
import { mapProduct, segregateCollection } from './helpers';

export const removeCollection =
  ({ cart, setCart }) =>
  async ({ appCtx, products }) => {
    const { regionCode, politicalId, priceGroupId, store } = appCtx;
    const isSoCom = isSodimacStandalone(store);
    const isTottusSA = isTottusStandalone(store);
    const cartId = CookieStorage.getCookie('cartId');
    const { OFFER_PRICE_LABEL, NORMAL_PRICE_LABEL } = _.get(appCtx, 'siteConfig.textDictionary', {});
    const toggles = _.get(appCtx, 'siteConfig.toggles', {});

    const patchCart = products.map(({ cartLineId, totalQuantity }) => ({
      op: 'replace',
      path: `${cartLineId}/quantityNumber`,
      value: totalQuantity - 1,
    }));
    const reqBody = {
      data: {
        cart: {
          patchCart,
        },
      },
      metadata: {
        priceGroup: 'default',
      },
    };

    reqBody.metadata.politicalAreaId = politicalId;
    reqBody.metadata.priceGroup = priceGroupId;

    const additionalHeaders = getCommerceHeaders(regionCode, store, true);

    const patchCartLineUrl = apiConfig.patchCartlineCommerceUrl(cartId, regionCode);

    const response = await httpService().patch(
      patchCartLineUrl,
      reqBody,
      {
        credentials: 'include',
      },
      additionalHeaders,
      'json'
    );

    if (isTottusSA && response.statusCode === 200) {
      updateCartQtyLimits(response);
    }

    const { data, statusCode } = response;
    const items = _.get(data, 'data.cart.cartLines', []);
    const totalProductsQuantityCount = _.get(data, 'data.cart.totalProductsQuantityCount', 0);
    const totalProductsCount = totalProductsQuantityCount;

    if (statusCode === 200 && items) {
      const mappedProducts = items.map((item) =>
        mapProduct(item, regionCode, { OFFER_PRICE_LABEL, NORMAL_PRICE_LABEL }, toggles, isSoCom)
      );
      const mappedItems = segregateCollection({
        mappedProducts,
        collection: cart.typeACollections,
        action: 'REMOVE',
        products: [],
        cartItems: cart.cartItems,
      });

      setCart({
        ...cart,
        ...mappedItems,
        totalProductsCount,
        isAtgPrice: false,
      });
    } else {
      const { errors } = data;
      Logger.error(`Failed to Remove Product ${JSON.stringify(products)}`);
      return errors || [];
    }
    return null;
  };
